(function() {
    'use strict';

    angular
        .module('gwApp')
        .controller('UserPasswordController', UserPasswordController);

    UserPasswordController.$inject = ['$scope', 'Principal', 'LoginService','$state','User','$uibModal','$uibModalInstance','MessageService','$timeout', 'entity'];

    function UserPasswordController ($scope, Principal, LoginService,$state,User,$uibModal,$uibModalInstance,MessageService,$timeout, entity) {
        var vm = this;
        vm.user = entity;


        $scope.save = function() {
            if(vm.user.password == "" || vm.user.password == null){
                MessageService.error("旧密码不能为空");
                return;
            }
            if (vm.user.password.length<4 || vm.user.password.length >100) {
                MessageService.error("旧密码长度在4-100位之间");
                return false;
            }
            if(vm.user.password2 == "" || vm.user.password2 == null){
                MessageService.error("新密码不能为空");
                return;
            }
            if (vm.user.password2.length<4 || vm.user.password2.length >100) {
                MessageService.error("新密码长度在4-100位之间");
                return false;
            }
            if (vm.user.confirmPassword == null || vm.user.confirmPassword == "") {
                MessageService.error("确认密码不能为空");
                return false;
            }
            if (vm.user.confirmPassword != vm.user.password2) {
                MessageService.error("确认密码与新密码不一致");
                return false;
            }
            if (vm.user.confirmPassword.length<4 || vm.user.confirmPassword.length >100) {
                MessageService.error("确认密码长度在4-100位之间");
                return false;
            }
            vm.isSaving = true;
            User.reset2({
                id: vm.user.id,
                username: vm.user.username,
                password: vm.user.password,
                password2: vm.user.password2
            }, function (res) {
                vm.isSaving = false;
                if(res.state == "201"){
                    MessageService.error('旧密码不正确');
                    return
                }
                if(res.state == "200"){
                    MessageService.success('重置密码成功');
                    $uibModalInstance.close(vm.user);
                }
            }, function (error) {
                vm.isSaving = false;
                MessageService.error("重置密码失败");
            });
        };
        $scope.modalHide = function(){
            $uibModalInstance.close(false);
        };
    }
})();
